// extracted by mini-css-extract-plugin
module.exports = {"socialIconWrapper":"SocialIcon_socialIconWrapper__vGyuo","socialIcon":"SocialIcon_socialIcon__URJJI"};